import { render, staticRenderFns } from "./upload-element.vue?vue&type=template&id=be5a6492&scoped=true&"
import script from "./upload-element.vue?vue&type=script&lang=js&"
export * from "./upload-element.vue?vue&type=script&lang=js&"
import style0 from "./upload-element.vue?vue&type=style&index=0&id=be5a6492&scoped=true&lang=scss&ref=stylesheet%2Fscss&"
import style1 from "./upload-element.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be5a6492",
  null
  
)

export default component.exports